/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import {
  ControlProps,
  RankedTester,
  rankWith,
  isStringControl,
  and,
  schemaMatches
} from '@jsonforms/core'

import { useJsonForms, withJsonFormsControlProps } from '@jsonforms/react'
import { withHandleChangeEmitter } from '../WithCustomHandlerHOC'
import CurrencyInput from 'react-currency-input-field'
import { CustomUISchema } from '../../constants'
import ToolTipOverlayComponent from '../../Components/ToolTipOverlay'

export const Currency: React.FC<ControlProps> = (props: ControlProps) => {
  const {
    label,
    handleChange,
    data,
    path,
    id,
    errors,
    schema,
    required,
    visible,
    enabled
  } = props

  const { core } = useJsonForms()

  const uischema = props.uischema as CustomUISchema
  const placeHolderText =
    'placeHolderText' in uischema ? uischema.placeHolderText : ''

  const toolTipText = 'toolTipText' in uischema ? uischema.toolTipText : ''

  const [showError, setShowError] = useState<boolean>(false)

  const getClass = () => {
    return errors && errors.length ? 'form-control is-invalid' : 'form-control'
  }

  const validate = (value: string | undefined) => {
    required && !value && core?.validationMode === 'ValidateAndShow'
      ? setShowError(true)
      : setShowError(false)
  }

  function handleBlur() {
    if (data) {
      if (data.slice(-1) === '.') {
        handleChange(path, data + '00')
        return
      }
      if (data.charAt(data.length - 2) === '.') {
        handleChange(path, data + '0')
        return
      }
      if (data.charAt(data.length - 3) !== '.') {
        handleChange(path, data + '.00')
      }
    }
  }

  function handleValueChange(value: string | undefined) {
    handleChange(path, value)
    validate(value)
  }

  return (
    <>
      {visible ? (
        <div className='form-group'>
          <label htmlFor={id} className='custom-input-label'>
            {label}
          </label>
          {toolTipText && toolTipText.length > 0 && (
            <ToolTipOverlayComponent
              toolTipText={toolTipText}
              placement='top'
              trigger='click'
            />
          )}
          <CurrencyInput
            id={id}
            placeholder={placeHolderText}
            name='input-name'
            className={getClass()}
            decimalsLimit={2}
            onValueChange={handleValueChange}
            value={data}
            prefix={'$'}
            onBlur={handleBlur}
            disabled={!enabled}
            data-testid='currency-input'
          />

          {(!!errors || showError) && (
            <div className='text-danger' data-testid='errors-div'>
              <span>{`${schema.title} is required`}</span>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export const currencyControlTester: RankedTester = rankWith(
  7,
  and(
    isStringControl,
    schemaMatches(
      // eslint-disable-next-line
      (schema: { hasOwnProperty: (arg0: string) => any }) =>
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isCurrency')
    )
  )
)

export const CurrencyControl = withJsonFormsControlProps(
  withHandleChangeEmitter(Currency)
)
